var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pa-2"},[(this.$route.params.roleid && this.$route.params.rolename)?_c('editPermissionComponent',{attrs:{"roleName":_vm.roleName,"roleId":_vm.roleId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }